<!-- <p>table-card-display works!</p> -->
<div class="mobile-table-card-wrapper">
  <div
    *ngFor="let data of dataSource; let i = index"
    class="mobile-table-card-container"
  >
    <div class="card-content">
      <div>
        No. <b>{{ i + 1 }}</b>
      </div>
      <div>
        First Name : <b>{{ data.firstName | titlecase }}</b>
      </div>
      <div>
        Last Name :
        <b>{{ data.lastName | titlecase }} </b>
      </div>
      <div>
        Email :
        <b>{{ data.email }}</b>
      </div>
      <div>
        Phone :
        <b>{{ data.phone }}</b>
      </div>
    </div>
    <div class="card-action">
      <button (click)="onShowDetails(data)" mat-raised-button>
        <mat-icon>remove</mat-icon>
      </button>
    </div>
  </div>
</div>
